
import NormalGameManager from "../../manager/NormalGameManager";
import O1HD from "../../../../engines/gameEngine";

const {ccclass, property} = cc._decorator;

@ccclass
export default class CapacityNode extends cc.Component {

    @property(cc.Label)
    lbHasChickenCount : cc.Label = null;
    @property(cc.Label)
    lbChickenCapacity : cc.Label = null;

    // onLoad () {}

    start () {

    }

    /**
     * 添加
     */
    onBtnAdd(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        //TODO
    }



    update (dt) {
        let gameLayer = NormalGameManager._instance;
        this.lbHasChickenCount.string = `${ gameLayer.getGameData().chickenData ? gameLayer.getGameData().chickenData .length : 0 }`;
        this.lbChickenCapacity.string = `/ ${ gameLayer.getGameData().chickenCoop.capacity }`;
    }
}
